import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AUTO_CANCELLED } from "../../utility-functions";
import Button from "@mui/material/Button";
import GModal from "../design/components/GModal";
import IntegrationSettingsModal from "./integrations/IntegrationSettingsModal";
import LeadSquaredConfigModal from "./integrations/LeadSquaredConfigModal";
import { CustomSearchableDropdown } from "../design/components/customComponents";
import DeskeraIcon from "../../assets/DeskeraIcon.png";
import GongIcon from "../../assets/gong.png"
import Dynamics from "../../assets/Dynamics-365-CRM-Logo.png";
import FreshworksIcon from "../../assets/Freshworks.png";
import HubspotIcon from "../../assets/HubspotIcon.svg";
import LeadSqauredIcon from "../../assets/Leadsquared.png";
import PipedriveIcon from "../../assets/pipedrive-logo.svg";
import SalesforceIcon from "../../assets/Salesforce.png";
import viaSocketIcon from "../../assets/viasocket.png";
import ZohoIcon from "../../assets/ZohoIcon.png";
import { settings02 } from "../../utility-functions/assetLoader";
import "./Integrations.css";
import GongSettingsModal from "./integrations/GongSettingsModal";
import ZohoDisconnectModal from "./integrations/ZohoDisconnectModal";

export default function IntegrationsTab(props) {
  const [selectedAppId, setSelectedAppId] = useState("");
  const [selectedAppName, setSelectedAppName] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [lsqConfigModalVisible, setLsqConfigModalVisible] = useState(false);
  const [integrationSettingsVisible, setIntegrationSettingsVisible] = useState({
    visible: false,
    name: "",
  });
  const [gongSettingsVisible, setGongSettingsVisible] = useState(false);
  const [zohoDisconnectModalVisible, setZohoDisconnectModalVisible] = useState(false);
  const [isZohoDisconnecting, setIsZohoDisconnecting] = useState(false);

  const navigate = useNavigate();

  const handleSearch = (searchValue) => {
    fetch(
      `https://plugservice-api.viasocket.com/plugins/search?key=${searchValue}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((item) => ({
            id: item.rowid,
            name: item.appslugname,
            combinations: item.combinations || [],
          }));
          setDropdownOptions(options);
        }
      })
      .catch((error) => console.error("Error searching data:", error));
  };

  const handleNextClick = () => {
    if (selectedAppName) {
      navigate("/via-socket-integration", {
        state: { selectedApp: selectedAppName },
      });
      setModalVisible(false);
    }
  };

  return (
    <div className="integrations-container nc-gray-900 regular-font">
      <div className="crm-integrations">
        <div className="title medium-font t5">CRM Integrations</div>
        <div className="content">
          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img src={HubspotIcon} alt="" />
              </div>
              <div className="lower-half">
                <p className="title medium-font">HubSpot</p>
                <p className="integration-btn">
                  {!props.hubspotAccess ? (
                    <Button
                      variant="contained"
                      onClick={props.handleHubspotConnect}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={props.handleHubspotDisconnect}
                    >
                      Disconnect
                    </Button>
                  )}
                  {props.hubspotAccess ? (
                    <Button
                      onClick={() =>
                        setIntegrationSettingsVisible({
                          name: "HubSpot",
                          visible: true,
                        })
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </p>
              </div>
            </div>
          )}
          <div className="integration-card">
            <div className="upper-half">
              <img src={PipedriveIcon} alt="" />
            </div>
            <div className="lower-half">
              <p className="title medium-font">Pipedrive</p>
              <p className="integration-btn">
                {!props.pipedriveAccess ? (
                  <Button
                    variant="contained"
                    onClick={props.handlePipedriveConnect}
                    disabled={props.status === AUTO_CANCELLED}
                  >
                    Connect
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className="disconnect-btn"
                    onClick={props.handlePipedriveDisconnect}
                  >
                    Disconnect
                  </Button>
                )}
              </p>
            </div>
          </div>

          <div className="integration-card">
            <div className="upper-half">
              <img
                className="zoho-img"
                src={ZohoIcon}
                alt=""
                style={{ width: "50px", height: "50px" }}
              />
            </div>
            <div className="lower-half">
              <p className="title medium-font">Zoho Phonebridge</p>
              <p className="integration-btn">
                {!props.zohoPhonebridgeAccess ? (
                  <Button
                    variant="contained"
                    onClick={props.handleZohoPhoneBridgeConnect}
                    disabled={props.status === AUTO_CANCELLED}
                  >
                    Connect
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className="disconnect-btn"
                    onClick={() => setZohoDisconnectModalVisible(true)}
                  >
                    Disconnect
                  </Button>
                )}
                {props.zohoPhonebridgeAccess ? (
                    <Button
                      onClick={() =>
                        setIntegrationSettingsVisible({
                          name: "Zoho",
                          visible: true,
                        })
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
              </p>
            </div>
          </div>

          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  className="zoho-img"
                  src={DeskeraIcon}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Deskera</p>
                <p className="integration-btn">
                  {!props.deskeraAccess ? (
                    <Button
                      variant="contained"
                      onClick={props.handleDeskeraConnect}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={props.handleDeskeraDisconnect}
                    >
                      Disconnect
                    </Button>
                  )}
                  {props.deskeraAccess ? (
                    <Button
                      onClick={() =>
                        setIntegrationSettingsVisible({
                          name: "Deskera",
                          visible: true,
                        })
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </p>
              </div>
            </div>
          )}
          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  src={LeadSqauredIcon}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Leadsquared</p>
                <p className="integration-btn">
                  {!Object.keys(props.leadSquaredConfig)?.length ? (
                    <Button
                      variant="contained"
                      onClick={() => setLsqConfigModalVisible(true)}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={() => props.handleLSQConfig({}, "delete")}
                    >
                      Disconnect
                    </Button>
                  )}
                  {Object.keys(props.leadSquaredConfig)?.length ? (
                    <Button
                      onClick={() => setLsqConfigModalVisible(true)}
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </p>
              </div>
            </div>
          )}

          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  className="zoho-img"
                  src={FreshworksIcon}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Freshworks</p>
                <p className="integration-btn">
                  {!props.freshworksAccess ? (
                    <Button
                      variant="contained"
                      onClick={props.handleFreshworksConnect}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={props.handleFreshworksDisconnect}
                    >
                      Disconnect
                    </Button>
                  )}
                  {props.freshworksAccess ? (
                    <Button
                      onClick={() =>
                        setIntegrationSettingsVisible({
                          name: "Freshworks",
                          visible: true,
                        })
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </p>
              </div>
            </div>
          )}
          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  src={Dynamics}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Microsoft Dynamics 365</p>
                <p className="integration-btn">
                  {!props.dynamicsAccess ? (
                    <Button
                      variant="contained"
                      onClick={props.handleDynamicsConnect}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={props.handleDynamicsDisconnect}
                    >
                      Disconnect
                    </Button>
                  )}
                </p>
              </div>
            </div>
          )}
          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  src={SalesforceIcon}
                  alt=""
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Salesforce</p>
                <div className="integration-btn">
                  {!props.salesforceAccess ? (
                    <>
                      <Button
                        variant="contained"
                        className="connect-btn"
                        onClick={props.handleSalesForceConnect}
                        disabled={props.status === AUTO_CANCELLED}
                      >
                        Connect
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      className="disconnect-btn"
                      onClick={props.handlesalesForceDisconnect}
                    >
                      Disconnect
                    </Button>
                  )}
                  {props.salesforceAccess ? (
                    <Button
                      onClick={() =>
                        setIntegrationSettingsVisible({
                          name: "Salesforce",
                          visible: true,
                        })
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          )}
          {props.canManageOrgLevelIntegrations && (
            <div className="integration-card">
              <div className="upper-half">
                <img
                  src={GongIcon}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <div className="lower-half">
                <p className="title medium-font">Gong</p>
                <div className="integration-btn">
                  {!props.gongAccess ? (
                    <>
                    <Button
                      variant="contained"
                      className="connect-btn"
                      onClick={props.handleGongConnect}
                      disabled={props.status === AUTO_CANCELLED}
                    >
                      Connect
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    className="disconnect-btn"
                    onClick={props.handleGongDisconnect}
                  >
                    Disconnect
                  </Button>
                  )}
                {props.gongAccess ? (
                    <Button
                      onClick={() =>
                        setGongSettingsVisible(true)
                      }
                      variant="contained"
                      style={{ width: "36px", minWidth: "36px", padding: 0 }}
                    >
                      {settings02(20, 20)}
                    </Button>
                  ) : null}
                </div>

              </div>
            </div>
          )}
          <div className="integration-card">
            <div className="upper-half">
              <img
                src={viaSocketIcon}
                alt="viaSocket"
                style={{ width: "40px", height: "40px" }}
              />
            </div>
            <div className="lower-half">
              <p className="title medium-font">viaSocket</p>
              <p className="integration-btn">
                <button
                  variant="contained"
                  style={{ width: "138px" }}
                  onClick={() => setModalVisible(true)}
                  disabled={props.status === AUTO_CANCELLED}
                >
                  Create Workflow
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
      <GModal
        visible={modalVisible}
        heading="Select an App"
        bodyWrapperStyle={isDropdownOpen ? { height: "200px" } : {}}
        body={
          <CustomSearchableDropdown
            label="Select an App"
            placeholder="Search apps..."
            options={dropdownOptions}
            width="100%"
            onDropdownOpen={() => setIsDropdownOpen(true)}
            onDropdownClose={() => setIsDropdownOpen(false)}
            selectedId={selectedAppId}
            onSelect={(id) => {
              setSelectedAppId(id);
              const selectedOption = dropdownOptions.find((o) => o.id === id);
              setSelectedAppName(selectedOption ? selectedOption.name : "");
            }}
            onSearch={handleSearch}
          />
        }
        disableCloseBtn={false}
        closeModal={() => setModalVisible(false)}
        bottomButtons={[
          <Button
            key="cancel"
            variant="outlined"
            className="cancel-button"
            onClick={() => setModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button
            key="next"
            variant="contained"
            onClick={handleNextClick}
            className="next-button"
          >
            Next
          </Button>,
        ]}
      />
      <IntegrationSettingsModal
        visible={integrationSettingsVisible.visible}
        closeModal={() => setIntegrationSettingsVisible(false)}
        integrationName={integrationSettingsVisible.name}
      />
      {lsqConfigModalVisible && (
        <LeadSquaredConfigModal
          visible={lsqConfigModalVisible}
          closeModal={() => setLsqConfigModalVisible(false)}
          config={props.leadSquaredConfig}
          handleSave={props.handleLSQConfig}
        />
      )}
      {gongSettingsVisible && (
        <GongSettingsModal
          visible={gongSettingsVisible}
          closeModal={() => setGongSettingsVisible(false)}
        />
      )}
      {zohoDisconnectModalVisible && 
        <ZohoDisconnectModal
          visible={zohoDisconnectModalVisible}
          closeModal={() => setZohoDisconnectModalVisible(false)}
          isDisconnecting={isZohoDisconnecting}
          onDisconnect={(deleteForAllUsers) => {
            setIsZohoDisconnecting(true);
            props.handleZohoPhoneBridgeDisconnect(deleteForAllUsers, () =>{
              setIsZohoDisconnecting(false)
              setZohoDisconnectModalVisible(false)
            }
            );
          }}
        />
      }
    </div>
  );
}
